import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCurrentPage } from "context/pages/pageSlice";
// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "dashboard/components/MDBox";
// import MDTypography from "dashboard/components/MDTypography";

// Material Dashboard 2 React example components
import DefaultNavbar from "components/layouts/DefaultNavbar";
import PageLayout from "components/layouts/PageLayout";

// Authentication layout components
import Footer from "components/layouts/SimpleFooter"

function CoverLayout({ coverHeight, image, children, lg, rest }) {
  const homePage = useSelector(selectCurrentPage);
  const dataNavBare = useMemo(()=> ({
    logo : `${process.env.REACT_APP_PUBLIC_URL}/img/logo/${homePage?.Navigation?.logo?.selectedImage}`,
    navigation : homePage?.Navigation.navBar?.slice(0, 4).map(item=>({
      [item.link.name] : item.link.slug
    }))
  }),[homePage]);

  return (
    <PageLayout>
      <DefaultNavbar
        data={dataNavBare}
        rest={rest}
        transparent
        light
      />
      <MDBox
        width="calc(100% - 2rem)"
        minHeight={coverHeight}
        borderRadius="xl"
        mx={2}
        my={2}
        pt={6}
        pb={28}
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image &&
            `${linearGradient(
              rgba(gradients.dark.main, 0.4),
              rgba(gradients.dark.state, 0.4)
            )}, url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MDBox mt={{ xs: -10, lg: -20 }} px={1} width="calc(100% - 2rem)" mx="auto">
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={11}  lg={lg}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      <Footer footerAbs />
    </PageLayout>
  );
}

// Setting default props for the CoverLayout
CoverLayout.defaultProps = {
  coverHeight: "35vh",
  lg : 4
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  coverHeight: PropTypes.string,
  image: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
